import React, { useState, useEffect, useRef } from 'react'; 
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useNavigate } from 'react-router-dom';

// Components 

import { useTranslation } from 'react-i18next';
import SelectPatient from './selectPatient/SelectPatient';
import Start from './start/Start';

const Consultation: React.FC = () => {

  const dispatch = useAppDispatch(); 
  const navigate = useNavigate(); 

  const { t } = useTranslation(); 
  const isMobile = useMediaQuery('(max-width:600px)');

  // Calculate sidebar width based on Sidebar.tsx logic
  const sidebarMinWidth = isMobile ? 70 : 125; 
  const [leftOffset, setLeftOffset] = useState(`${sidebarMinWidth}px`);
  
  useEffect(() => {
    const calculateLeftOffset = () => {
      const vwWidth = window.innerWidth * 0.05;
      const effectiveWidth = Math.max(vwWidth, sidebarMinWidth);
      setLeftOffset(`${effectiveWidth}px`);
    };

    calculateLeftOffset();
    window.addEventListener('resize', calculateLeftOffset);
    return () => window.removeEventListener('resize', calculateLeftOffset);
  }, [isMobile, sidebarMinWidth]);


  const colors = useAppSelector(state => state.theme.colors);
  const section = useAppSelector(state => state.consultation.section); 

  // --

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center',
      justifyContent: 'flex-start', // Align content to top
      width: `calc(100vw - ${leftOffset})`, // Adjust width based on sidebar
      height: 'calc(100vh - 5vh)', // Adjust height to account for NavBar
      position: 'absolute',
      top: '5vh', // Position below NavBar
      left: leftOffset, // Position next to Sidebar
      bottom: 0,
      backgroundColor: colors?.interface,
      transition: 'left 0.2s ease-out, width 0.2s ease-out', // Smoother transition
      overflowY: 'auto', // Allow vertical scrolling for the whole section if needed
      overflowX: 'hidden', // Prevent horizontal scrolling
      padding: isMobile ? 1 : 2, // Add some padding, more on desktop
      boxSizing: 'border-box',
    }}>

      {/* <SelectPatient /> */}

      {/* The Start component will handle its own layout within this container */}
      <Start />

    </Box>
  );
};

export default Consultation;